import * as React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { WardInfoContent } from './WardInfoContent'
import { PlaceInfoContent } from './PlaceInfoContent'
import type { WardInfo } from '@/types/ward'

export type InfoData = 
  | { type: 'ward'; data: WardInfo }
  | { type: 'place'; data: __esri.Graphic }
  | null

interface UnifiedInfoDialogProps {
  info: InfoData
  onClose?: () => void
}

export function UnifiedInfoDialog({ info, onClose }: UnifiedInfoDialogProps) {
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const [open, setOpen] = React.useState(!!info)

  React.useEffect(() => {
    setOpen(!!info)
  }, [info])

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen)
    if (!newOpen) {
      onClose?.()
    }
  }

  const getTitle = () => {
    if (!info) return ''
    if (info.type === 'ward') {
      return `Phường ${info.data.xaphuong}`
    } else {
      const name = info.data.attributes?.ten || info.data.attributes?.Ten || 'Địa điểm'
      return name
    }
  }

  const getDescription = () => {
    if (!info) return ''
    if (info.type === 'ward') {
      return `Chi tiết thông tin về phường ${info.data.xaphuong}`
    } else {
      return 'Chi tiết thông tin về địa điểm'
    }
  }

  const renderContent = () => {
    if (!info) return null
    if (info.type === 'ward') {
      return <WardInfoContent ward={info.data} />
    } else {
      return <PlaceInfoContent attributes={info.data.attributes} />
    }
  }

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent className="fixed right-4 bottom-4 left-auto top-auto w-80 border shadow-2xl bg-white translate-x-0 translate-y-0 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-right-1/2 data-[state=closed]:slide-out-to-bottom-1/2 data-[state=open]:slide-in-from-right-1/2 data-[state=open]:slide-in-from-bottom-1/2">
          <DialogHeader className="sr-only">
            <DialogTitle>{getTitle()}</DialogTitle>
            <DialogDescription>{getDescription()}</DialogDescription>
          </DialogHeader>
          {renderContent()}
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Drawer open={open} onOpenChange={handleOpenChange}>
      <DrawerContent className="max-h-[85vh] bg-white">
        <DrawerHeader className="text-left">
          <DrawerTitle className="text-2xl">{getTitle()}</DrawerTitle>
          <DrawerDescription className="sr-only">
            {getDescription()}
          </DrawerDescription>
        </DrawerHeader>
        <div className="px-4 pb-4 overflow-y-auto">
          {renderContent()}
        </div>
      </DrawerContent>
    </Drawer>
  )
}